import { render, staticRenderFns } from "./comnav.vue?vue&type=template&id=be0527f4&"
import script from "./comnav.vue?vue&type=script&lang=js&"
export * from "./comnav.vue?vue&type=script&lang=js&"
import style0 from "./comnav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports